import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-stakeholders-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-stakeholders-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationStakeholdersItamsConstants } from "./view-application-stakeholders-itams.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { InformalTradeService } from "../../../../../shared/services/modules/informal-trade.service";
import { ViewApplicationDetailsItamsConstants } from "../view-application-details-itams/view-application-details-Itams.constants";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationStakeholdersItamsComponent = class ViewApplicationStakeholdersItamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    routerParamsService;
    recipientListService;
    informalTradeService;
    appController;
    changeDetectorRefs;
    tradersForm;
    // traders
    disableTraderRecipientFilter = true;
    traderConfigurableLabel = "Trader";
    traderDisableAddButton = false;
    traderRecipientGroups = [];
    traderDisableEditButton = false;
    saveBtnPlaceholder = ViewApplicationStakeholdersItamsConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    setTradersObservableSubscription;
    getStepMetaObservableSubscription;
    getTradersSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, routerParamsService, recipientListService, informalTradeService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.informalTradeService = informalTradeService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getApplication();
        this.getMetaData();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getTradersControl() {
        return this.tradersForm.get("traders");
    }
    onBtnSaveClicked() {
        if (this.tradersForm.valid) {
            const tradersObject = this.tradersForm.get("traders").value;
            const tradersArray = tradersObject?.recipients;
            if (tradersArray.length === 0 || tradersArray === null) {
                this.appController.showMessage("An application needs to have at minimum 1 trader", AlertType.Warning);
                return;
            }
            if (tradersArray.length > 0) {
                tradersArray.forEach(trader => {
                    RecipientUtils.removeRecipientProperties(trader);
                });
            }
            const params = {
                traders: tradersArray
            };
            this.setTradersObservableSubscription = this.informalTradeService.setTradersObservable(this.application.jobId, params).subscribe({
                next: () => {
                    this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                }
            });
        }
        else {
            this.appController.showMessage(ViewApplicationStakeholdersItamsConstants.APPLICATION_ERROR_MESSAGE, AlertType.Error);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const tradersForm = this.aflaModuleStrategyService.form.get("tradersForm");
        this.tradersForm = tradersForm;
    }
    getMetaData() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.traderRecipientGroups = stepMeta.traderGroup;
            if (this.traderRecipientGroups[0]) {
                this.traderRecipientGroups = this.recipientListService.checkStepMetaRecipientGroups(this.traderRecipientGroups);
            }
            this.changeDetectorRefs.detectChanges();
            this.getTraders();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    onGetTradersCompleted(traders) {
        if (traders && traders.length > 0) {
            const tradersControl = this.tradersForm.get("traders");
            this.recipientListService.setRecipients(traders, false, tradersControl);
        }
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService.getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationStakeholdersItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.tradersForm.reset();
            const application = response.value[0];
            this.application = application;
            this.changeDetectorRefs.detectChanges();
        }
    }
    getTraders() {
        this.getTradersSubscription = this.informalTradeService.getTradersObservable(this.application.jobId).subscribe({
            next: (recipientResponse) => {
                if (recipientResponse && recipientResponse.length > 0) {
                    const traders = recipientResponse;
                    this.onGetTradersCompleted(traders);
                    this.changeDetectorRefs.detectChanges();
                }
            }, error: err => {
                this.appController.handleServerErrorMessage("traders", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: InformalTradeService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationStakeholdersItamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-stakeholders-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationStakeholdersItamsComponent);
export { ViewApplicationStakeholdersItamsComponent };
